import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useRef, useState } from 'react';
import { useRouter } from '../../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Alert, Box, Button, ButtonDropdown, Checkbox, Container, ExpandableSection, FileUpload, FormField, Input, Link, SpaceBetween, Spinner, Table, TimeInput, Token } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { Icon } from '@mdi/react';
import Favorites from '../../../../../components/extras/Favorites';
import { btnWarn, ItemMailTemplate, ItemMailTemplateFile } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, fileToBase64, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../commons/functions';

import DPModal from '../../../../../components/DPModal';
import BadgeCustom from '../../../../../components/extras/BadgeCustom';
import SelectUserType from '../../../../../components/selects/selectUserTypes';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';

import FroalaEditorComponent from 'react-froala-wysiwyg';

import { mdiAccountMultipleCheckOutline, mdiEmailFastOutline, mdiFilterVariant, mdiVectorIntersection, mdiVectorUnion } from '@mdi/js';
import { addMonths } from 'date-fns';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/plugins/table.min.css';
import "froala-editor/js/plugins/align.min.js";
import "froala-editor/js/plugins/code_beautifier.min.js";
import "froala-editor/js/plugins/code_view.min.js";
import "froala-editor/js/plugins/font_size.min.js";
import "froala-editor/js/plugins/image.min.js";
import "froala-editor/js/plugins/link.min.js";
import "froala-editor/js/plugins/lists.min.js";
import "froala-editor/js/plugins/paragraph_format.min.js";
import "froala-editor/js/plugins/quick_insert.min.js";
import "froala-editor/js/plugins/quote.min.js";
import "froala-editor/js/plugins/table.min.js";
import ConfirmDelete from '../../../../../components/extras/ConfirmDelete';
import Spacer from '../../../../../components/extras/Spacer';
import MPModal from '../../../../../components/MPModal';
import SelectCharges from '../../../../../components/selects/SelectCharges';
import SelectCheck from '../../../../../components/selects/selectChecks';
import SelectGroup from '../../../../../components/selects/selectGroups';



export const CommMailingsQueuePage = () => {
  const { menu, data, parameters } = useGlobalState();
  const [attachments, setAttachments] = React.useState<ItemMailTemplate[]>([]);
  useGlobalState();
  const { navigate } = useRouter();





  const [mailTemplate, setMailTemplate] = useState<ItemMailTemplate>();
  const [mailTemplates, setMailTemplates] = useState<ItemMailTemplate[]>([]);
  const [periods, setPeriods] = useState<any[]>([]);
  const [showConfirmDelete, setShowConfirmDelete] = useState<boolean>(false);
  const [userCount, setUserCount] = useState<number>(0);
  const [sendingTestEmail, setSendingTestEmail] = useState<boolean>(false);
  const [loadingCount, setLoadingCount] = useState<boolean>(false);
  const editorRef = useRef<any>(null);
  const mountedRef = useRef(false);
  const handlePaste = async (clipboardEvent: ClipboardEvent) => {

    const items = clipboardEvent.clipboardData?.items;
    if (!items) return;
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.type.indexOf("image") === 0) {
        const file = item.getAsFile();
        if (!file) return;

        clipboardEvent.preventDefault();
        clipboardEvent.stopPropagation();
        // 1. Convert to Base64
        const reader = new FileReader();
        reader.onload = async (e) => {
          const base64Data = e.target?.result as string;

          try {
            // 2. Upload to server
            const response = await fetch(`${getUrlVersion()}/resources/emails/emails.image.aspx`, {
              method: "POST",
              body: JSON.stringify({
                file: base64Data.split(',')[1],
                name: file.name,
                type: file.type,
                id: Date.now().toString()
              }),
              headers: { "Content-Type": "application/json" }
            });

            const result = await response.json();
            const imageUrl = result.url || result;

            const editor = editorRef.current?.editor;

            if (editor) {
              // Insert the image HTML
              editor.html.insert(`<img src="${imageUrl}" />`);

              // Focus the editor after insertion
              editor.events.focus();
            }

            // 4. Trigger synchronization
            editorRef.current?.editor.events.trigger('contentChanged');
          } catch (error) {
            console.error("Upload failed", error);
          }
        };

        reader.readAsDataURL(file);
        return false;
      }
    }
  };

  const handleSendTestEmail = async () => {
    try {
      if (mailTemplate?.html) {

        setMailTemplate({ ...mailTemplate, html: mailTemplate?.html.replace(/<p[^>]*data-f-id="pbf"[^>]*>.*?<\/p>/gi, "") });
        setSendingTestEmail(true);

        const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-routing': '/private/admin/mailings/testsend',
            'JWT': getCookie("JWT"),
            //  
          },
          body: JSON.stringify({
            idMailTemplate: mailTemplate?.idMailTemplate,
            subject: mailTemplate?.subject,
            html: mailTemplate?.html,
          }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }
        const data = await response.json();
        addNotificationStatus(data, setData);
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setSendingTestEmail(false) }
  }
  const handleUpdateEmail = async () => {
    try {
      if (mailTemplate?.html) {
        setMailTemplate({
          ...mailTemplate, html: mailTemplate?.html.replace(
            /<p[^>]*data-f-id="pbf"[^>]*>.*?<\/p>/gi,
            ""
          )
        });

        setLoading(true)

        const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-routing': '/private/admin/mailings/update',
            'JWT': getCookie("JWT"),
            //  
          },


          body: JSON.stringify({
            idMailTemplate: mailTemplate?.idMailTemplate,
            subject: mailTemplate?.subject,
            html: mailTemplate?.html,
            dateSend: mailTemplate?.dateSend + " " + mailTemplate?.timeSend,
            idStatuses: mailTemplate?.idStatuses,
            idChecks: mailTemplate?.idChecks,
            idGroups: mailTemplate?.idGroups,
            idCharges: mailTemplate?.idCharges,
            idUserTypes: mailTemplate?.idUserTypes,
            intersection: mailTemplate?.intersection,
            limit: 20,
            columns: "idMailTemplate,  subject, html, replyTo, status, dateCreated, dateModified, dateSend, idGroups, idStatuses, isActiveMailTemplate, isDeleteMailTemplate, copy, idCharges, idChecks , cc, totalUsers, intersection",
            orderBy: "dateSend",
            order: "desc"
          }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }
        const data = await response.json();
        addNotificationStatus(data, setData);
        if (data.code == 0) {
        }
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }
  }
  const handleDeleteEmail = async (idMailTemplate: number) => {
    try {
      setLoading(true)

      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/mailings/delete',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify({
          idMailTemplate: idMailTemplate
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const data = await response.json();
      addNotificationStatus(data, setData);
      if (data.code == 0) {
        setMailTemplate(data.mailTemplate);
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }
  }
  const handleGetEmail = async (idMailTemplate: number) => {
    try {
      setLoading(true)

      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/mailings/get',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify({
          idMailTemplate: idMailTemplate,
          columns: "idMailTemplate,  subject, html, replyTo, status, dateCreated, dateModified, dateSend, idGroups, idStatuses, isActiveMailTemplate, isDeleteMailTemplate, copy, idCharges, idChecks , cc, idUserTypes, totalUsers, intersection",
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const data = await response.json();
      addNotificationStatus(data, setData);
      if (data.code == 0) {
        setMailTemplate(data.mailTemplate);
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }
  }
  const handleUpdateStatusEmail = async (idEmailTemplate: number, status: number) => {
    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/mailings/update',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify({
          idMailTemplate: idEmailTemplate,
          status: status,
          limit: 20,
          columns: "idMailTemplate,  subject, html, replyTo, status, dateCreated, dateModified, dateSend, idGroups, idStatuses, isActiveMailTemplate, isDeleteMailTemplate, copy, idCharges, idChecks , cc, intersection",
          orderBy: "dateSend",
          order: "desc",
          year: parameters.period.split("-")[0],
          month: parameters.period.split("-")[1]
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const data = await response.json();
      addNotificationStatus(data, setData);
      if (data.code == 0) {
        setMailTemplates(data.mailTemplates);
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }
  }
  const handleDeleteAttachment = async (FILE: ItemMailTemplateFile) => {
    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/mailings/attachments/delete',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify(FILE),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const data = await response.json();
      addNotificationStatus(data, setData);
      if (data.code == 0) {
        setMailTemplate(data.mailTemplate);
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }
  }
  const handleAttachments = async (FILE: ItemMailTemplateFile) => {
    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        timeout: 600000,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/mailings/attachments/upload',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify(FILE),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const data = await response.json();
      addNotificationStatus(data, setData);
      if (data.code == 0) {
        setMailTemplate(data.mailTemplate);
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }
  }
  const handleGetEmails = async () => {
    try {
      if (parameters.period !== "") {
        setLoading(true)
        const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-routing': '/private/admin/mailings/list',
            'JWT': getCookie("JWT"),
            //  
          },
          body: JSON.stringify({
            limit: 40,
            columns: "idMailTemplate,  subject, html, replyTo, status, dateCreated, dateModified, dateSend, idGroups, idStatuses, isActiveMailTemplate, isDeleteMailTemplate, copy, idCharges, idChecks , cc, totalUsers, idUserTypes, intersection",
            month: parameters.period.split("-")[1],
            year: parameters.period.split("-")[0],
            orderBy: "dateSend",
            order: "desc"
          }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }
        const data = await response.json();
        addNotificationStatus(data, setData);
        if (data.code == 0) {
          setMailTemplates(data.mailTemplates);
        }
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }
  }


  const handleGetCounter = async () => {
    try {
      setLoadingCount(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/users/users.count',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify({
          intersection: mailTemplate?.intersection,
          idGroups: mailTemplate?.idGroups,
          idStatuses: mailTemplate?.idStatuses,
          idCharges: mailTemplate?.idCharges,
          idChecks: mailTemplate?.idChecks,
          idUserTypes: mailTemplate?.idUserTypes,
          isActiveUser: 1
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const data = await response.json();
      addNotificationStatus(data, setData);
      if (data.code == 0) {
        setUserCount(data.count);
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoadingCount(false) }
  }

  useEffect(() => {
    if (parameters.period)
      handleGetEmails();
  }, [parameters.period]);

  useEffect(() => {
    const filesToProcess = mailTemplate?.files?.filter(file => file.loaded === false)
    filesToProcess?.forEach(file => {
      handleAttachments(file);
    })
  }, [mailTemplate?.files]);


  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.split("?")[1]);
      const id = params.get("id");
      if (id) {
        if (!mountedRef.current) {
          mountedRef.current = true;
          handleGetEmails();
        }
        handleGetEmail(id ? parseInt(id) : 0);
      }
      else {
        setMailTemplate(undefined);
        handleGetEmails();
      }
    };

    window.addEventListener("hashchange", handleHashChange);
    // also trigger once on mount
    handleHashChange();

    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);


  useEffect(() => {
    if (mailTemplate?.idUserTypes || mailTemplate?.idStatuses || mailTemplate?.idGroups || mailTemplate?.idCharges || mailTemplate?.idChecks || mailTemplate?.intersection)
      handleGetCounter()
  }, [mailTemplate?.idUserTypes, mailTemplate?.idStatuses, mailTemplate?.idGroups, mailTemplate?.idCharges, mailTemplate?.idChecks, mailTemplate?.intersection]);



  const handleFileChange = async (files: File[]) => {
    try {
      // Use Promise.all to concurrently convert all files to Base64
      const base64Results = await Promise.all(files.map(fileToBase64));

      // Map the results back to an array of objects that include the Base64 data
      const attachmentsWithBase64 = base64Results.map(result => ({
        idMailTemplateFile: 0,
        idMailTemplate: mailTemplate ? mailTemplate.idMailTemplate : 0,
        fileName: result.file.name,
        fileContent: result.base64,
        fileSize: result.file.size,
        hashMailTemplateFile: '',
        loaded: false,
        deleted: false,
      }));
      setMailTemplate((prev: ItemMailTemplate | undefined) => {
        if (!prev) return prev;
        return {
          ...prev,
          // Use the spread operator on the entire new array to append all new files
          files: [...(prev?.files || []), ...attachmentsWithBase64]
        };
      });
    } catch (error) {
      // Handle error state if necessary
    }
  };
  const totalFilters = mailTemplate ? (mailTemplate?.idCharges ? mailTemplate?.idCharges?.length : 0) +
    (mailTemplate?.idUserTypes?.length ? mailTemplate?.idUserTypes?.length : 0) +
    (mailTemplate?.idChecks?.length ? mailTemplate?.idChecks?.length : 0) +
    (mailTemplate?.idStatuses?.length ? mailTemplate?.idStatuses?.length : 0) +
    (mailTemplate?.idGroups?.length ? mailTemplate?.idGroups?.length : 0) : 0;
  return (
    <CustomAppLayout
      toolsHide={true}
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <SpaceBetween size="s">
          <Header variant="h1" actions={
            <SpaceBetween direction="horizontal" size="s">
              {mailTemplate !== undefined && (

                <Button variant="link" onClick={() => {
                  //handleGetEmails();
                  navigate('comm/mailings/queue');
                }}>Volver a la lista</Button>)}
              <Favorites />
            </SpaceBetween>
          }>Encolamientos de emails</Header>
          {mailTemplate && (
            <Container
              disableContentPaddings
              disableFooterPaddings
              disableHeaderPaddings
              style={{
                root: {
                  borderWidth: "0px",
                  boxShadow: "none"
                },
                footer: {
                  root: {},
                  divider: {
                    borderWidth: "0px",
                  }
                }
              }}
              variant="default"
              footer={

                <Box>
                  <Spacer height={10} />
                  <Box float='left'>

                    <Button disabled={mailTemplate.status !== 0} variant="normal" onClick={() => {
                      setShowConfirmDelete(true)
                    }} style={{ root: btnWarn }}>Eliminar</Button>
                  </Box>
                  <Box float='right'>

                    <SpaceBetween direction="horizontal" size="s">
                      <Button disabledReason='No se puede enviar una prueba de un correo sin contenido' disabled={!mailTemplate?.html} variant="normal" loading={sendingTestEmail} onClick={() => {
                        handleSendTestEmail();
                      }}><Icon path={mdiEmailFastOutline} size={1} />{" "}Prueba</Button>

                      <ButtonDropdown
                        disabled={mailTemplate.status !== 0}
                        onItemClick={(e) => {
                          if (e.detail.id === "saveclose") {
                            handleUpdateEmail();
                            setTimeout(() => {
                              navigate("comm/mailings/queue");
                            }, 0);

                          }
                        }}
                        items={[
                          {
                            text: `${mailTemplate.idMailTemplate === 0 ? "Crear" : "Guardar"} y cerrar`,
                            id: "saveclose",
                            disabled: mailTemplate.status !== 0
                          }
                        ]}
                        mainAction={{
                          disabled: mailTemplate.status !== 0,
                          text: mailTemplate.idMailTemplate === 0 ? "Crear" : "Guardar", onClick: () => {
                            handleUpdateEmail();
                          }
                        }}
                        variant="primary"
                      />

                    </SpaceBetween>

                  </Box>
                </Box>} >

              <SpaceBetween direction="vertical" size="s">
                {mailTemplate.status !== 0 && (
                  <Alert type="warning" header="Advertencia">
                    Este correo solo puede ser editado en el estado de "Borrador". Para realizar cambios, cancele el envío o cree una copia del correo.
                  </Alert>
                )}
                <FormField label="Asunto">
                  <Input placeholder="Asunto del email" value={mailTemplate?.subject || ''} onChange={(e) => {
                    setMailTemplate({ ...mailTemplate, subject: e.detail.value });
                  }} />
                </FormField>
                <SpaceBetween direction="horizontal" size="s">

                  <FormField label="Fecha de envío">
                    <DPModal start={new Date()} date={mailTemplate?.dateSend} onConfirm={(date) => {
                      setMailTemplate({ ...mailTemplate, dateSend: date });
                    }} />
                  </FormField>
                  <FormField label="Hora">
                    <TimeInput format='hh:mm' placeholder="Hora" value={mailTemplate?.timeSend || ''} onChange={(e) => {
                      setMailTemplate({ ...mailTemplate, timeSend: e.detail.value });
                    }} />

                  </FormField>
                </SpaceBetween>
                <ExpandableSection header={<Header variant='h3'>Adjuntos

                  {mailTemplate.files && mailTemplate.files.length > 0 ? (` (${mailTemplate.files.length})`) : ""}
                </Header>} variant="container" defaultExpanded={false}>

                  {mailTemplate.files && mailTemplate.files.length > 0 && (
                    <SpaceBetween direction="vertical" size="s">
                      <SpaceBetween direction="horizontal" size="s">
                        {
                          mailTemplate.files.map((file: ItemMailTemplateFile) => (
                            <Link onClick={() => {
                              window.open(`https:///store.planeadores.cl/temp/emails/${file.idMailTemplateFile}.${file.fileName.split('.').pop()}`, '_blank');
                              // handle link click logic here
                            }}>
                              <Token
                                label={file.fileName}
                                {...(!file.deleted && mailTemplate.status === 0 && {
                                  onDismiss: () => {
                                    handleDeleteAttachment(file)
                                  }
                                })}
                              />

                            </Link>
                          ))
                        }
                      </SpaceBetween>

                    </SpaceBetween>
                  )}
                  <Spacer height={20} />
                  <FileUpload
                    onChange={({ detail }) => {
                      handleFileChange(detail.value);
                    }}
                    accept='.txt,.jpeg,.jpg,.png,.pdf,.doc,.docx,.xls,.xlsx'
                    i18nStrings={{
                      uploadButtonText: e => "Seleccionar archivo",
                      dropzoneText: e => "Arrastre archivo para cargar",
                      removeFileAriaLabel: e => `Eliminar archivo ${e + 1}`,
                      limitShowFewer: "Show fewer files",
                      limitShowMore: "Show more files",
                      errorIconAriaLabel: "Error",
                      warningIconAriaLabel: "Warning"
                    }}
                    showFileLastModified
                    showFileSize
                    showFileThumbnail
                    tokenLimit={1} value={[]} />
                </ExpandableSection>
                <ExpandableSection header={
                  <Header variant='h3'>
                    Filtros de envío
                    {totalFilters > 0 ? (<>{' '}<Icon path={mdiFilterVariant} size={1} />{totalFilters}</>) : null}
                    {" "}
                    {totalFilters > 0 ?
                      loadingCount ? <Spinner /> : <><Icon path={mdiAccountMultipleCheckOutline} size={1} />{userCount}</>
                      : null}


                  </Header>} variant="container" defaultExpanded={totalFilters > 0}>

                  <SpaceBetween direction="horizontal" size="s">
                    <div style={{ maxWidth: 250 }}>
                      <FormField label={
                        <>
                          Condición
                          {/* Conditional logic to choose AND or OR icon/text */}
                          {mailTemplate?.intersection === 1 ? (
                            <span>{" "}
                              <Link><Icon path={mdiVectorIntersection} size={0.75} />
                                AND</Link>
                            </span>
                          ) : (
                            <span>{" "}
                              <Link><Icon path={mdiVectorUnion} size={0.75} />
                                OR</Link>
                            </span>
                          )}
                        </>
                      }
                        constraintText={<>Defina si los filtros aplican como intersección (AND) o unión (OR)</>}
                      >
                        <Checkbox checked={mailTemplate?.intersection === 1} onChange={(e) => {
                          setMailTemplate({ ...mailTemplate, intersection: e.detail.checked ? 1 : 0 });
                        }}>Usar intersección de filtros</Checkbox>

                      </FormField>
                    </div>
                    <div style={{ maxWidth: 250 }}>
                      <FormField label="Tipos">
                        <SelectUserType value={mailTemplate.idUserTypes} single={false} onSelect={(selected: number[]) => {
                          setMailTemplate({ ...mailTemplate, idUserTypes: selected });
                        }}
                          tokenLimit={0}
                        />

                      </FormField>
                    </div>
                    {/*
                    <div style={{ maxWidth: 250 }}>
                      <FormField label="Estados">
                        <SelectUserStatus single={false} value={mailTemplate.idStatuses}
                          tokenLimit={0}
                          onSelect={(selectedStatuses: number[]) => {
                            // Map the array of objects to an array of IDs (numbers)
                            setMailTemplate({
                              ...mailTemplate,
                              idStatuses: selectedStatuses // Save the array of IDs
                            });
                          }} />

                      </FormField>
                    </div>
                     */}
                    <div style={{ maxWidth: 250 }}>
                      <FormField label="Grupos">
                        <SelectGroup
                          single={false}
                          tokenLimit={0}
                          // Assuming mailTemplate.idGroups holds the array of selected group IDs
                          value={mailTemplate.idGroups}

                          // 💡 FIX: onSelect must receive an array of ItemGroup objects
                          onSelect={(selectedGroups: number[]) => {
                            // Map the full objects back to an array of IDs (numbers) before setting state
                            setMailTemplate({
                              ...mailTemplate,
                              idGroups: selectedGroups
                            });
                          }}
                        />

                      </FormField>
                    </div>
                    <div style={{ maxWidth: 250 }}>
                      <FormField label="Chequeos"><SelectCheck
                        single={false}
                        tokenLimit={0}
                        value={mailTemplate.idChecks}
                        onSelect={(selectedChecks: number[]) => {
                          setMailTemplate({ ...mailTemplate, idChecks: selectedChecks });
                        }} />

                      </FormField>
                    </div>
                    <div style={{ maxWidth: 250 }}>
                      <FormField label="Cargos">
                        <SelectCharges
                          single={false}
                          tokenLimit={0}

                          // Pass the Charge IDs array for pre-selection
                          value={mailTemplate.idCharges}

                          // REMOVE the extraneous 'charges' prop
                          // charges={data.checks} 

                          onSelect={(selectedCharges: number[]) => {
                            // This handler type is now 100% correct, resolving the previous error!
                            setMailTemplate({
                              ...mailTemplate,
                              idCharges: selectedCharges //.map(charge => charge.idCharge)
                            });
                          }}
                        />

                      </FormField>
                    </div>
                  </SpaceBetween>
                </ExpandableSection>
                <div style={{ marginTop: 15 }}>
                  <FroalaEditorComponent
                    ref={editorRef}
                    key={"ACTIVATION_KEY2"}
                    tag="textarea"
                    onModelChange=
                    {(model: any) => setMailTemplate({ ...mailTemplate, html: model })}
                    model={mailTemplate?.html || ""}
                    config={{
                      imageUpload: false,
                      imagePaste: false,
                      pastePlain: true,
                      useClasses: false,
                      events: {
                        /*
                        'paste.after': function (originalEvent: any) {
                          handlePaste(originalEvent);
                        },
                        */
                        initialized: function () {
                          const editorEl = editorRef.current?.editor?.$el[0];
                          editorEl?.addEventListener("paste", handlePaste);
                          if (editorEl) {

                          }
                        },
                      },
                      toolbarButtons: [
                        "clearFormatting", "alert", "undo", "redo", "blockquote", "bold", "italic", "underline", "strikeThrough", "subscript", "superscript", "fontFamily", "fontSize", "textColor", "alignLeft", "alignCenter", "formatOLSimple", "alignRight", "alignJustify", "lineHeight", "outdent", "indent", "insertLink", "insertImage", "insertVideo", "insertTable", "insertHR", "selectAll", "html", "help",
                      ],
                      pluginsEnabled: [
                        "paragraphStyle", "image", "codeView", "align", "table", "lists", "link", "clearFormatting", "quote", //"paste"
                      ],
                    }
                    }
                  />
                </div>
              </SpaceBetween>
            </Container>


          )}
          {!mailTemplate && (

            <Table
              variant='embedded'
              filter={
                <FormField label="Mes de consulta">
                  <div style={{ width: 130 }}>
                    <MPModal
                      width={120}
                      today prevMonth nextMonth
                      end={addMonths(new Date(), 1)}
                      date={`${parameters.period}`}
                      onConfirm={(date) => {
                        setParameters({ ...parameters, period: date.period, month: date.month, year: date.year });
                      }}
                    />
                  </div>
                </FormField>}
              cellVerticalAlign='top'
              columnDefinitions={[
                {
                  id: "dateCreated",
                  header: "Fecha",
                  cell: (item) => <FormField label={item.dateCreated}>{item.timeCreated}</FormField>,
                  minWidth: 100,
                },
                {
                  id: "subject",
                  header: "Asunto",
                  cell: (item) => <FormField label={<Link href={`#comm/mailings/queue?id=${item.idMailTemplate}`}>{item.subject}</Link>}>
                    {item.idUserTypes?.map((id: number) => {
                      const user = data.usersTypes?.find((u: any) => u.idUserType === id);
                      if (!user) return null;
                      return (<BadgeCustom key={id} color="blue" size='small'>{user.userType}</BadgeCustom>);
                    })}
                    {item.idGroups?.map((id: number) => {
                      const user = data.groups?.find((u: any) => u.idGroup === id);
                      if (!user) return null;
                      return (<BadgeCustom key={id} color="dark" size='small'>{user.group}</BadgeCustom>);
                    })}
                    {item.idStatuses?.map((id: number) => {
                      const user = data.usersStatuses?.find((u: any) => u.idUserStatus === id);
                      if (!user) return null;
                      return (<BadgeCustom key={id} color="lime" size='small'>{user.status}</BadgeCustom>);
                    })}

                    {item.idCharges?.map((id: number) => {
                      const user = data.charges?.find((u: any) => u.idCharge === id);
                      if (!user) return null;
                      return (<BadgeCustom key={id} color="orange" size='small'>{user.charge}</BadgeCustom>);
                    })}

                    {item.idChecks?.map((id: number) => {
                      const user = data.checks?.find((u: any) => u.idCheck === id);
                      if (!user) return null;
                      return (<BadgeCustom key={id} color="violet" size='small'>{user.check}</BadgeCustom>);
                    })}
                  </FormField>,
                },
                {
                  id: "dateSend",
                  header: "Programado",
                  cell: (item) => <FormField label={item.dateSend}>{item.timeSend}</FormField>,
                  minWidth: 100,
                },
                {
                  id: "status",
                  header: "Estado",
                  cell: (item) => {
                    switch (item.status) {
                      case 0: return <BadgeCustom color="light">Borrador</BadgeCustom>;
                      case 1: return <BadgeCustom color="violet">Pendiente</BadgeCustom>;
                      case 3: return <BadgeCustom color="green">Enviado</BadgeCustom>;
                      case 2: return <BadgeCustom color="lime">Enviando</BadgeCustom>;
                      default: return <BadgeCustom color="grey">Desconocido</BadgeCustom>;
                    }
                  },
                  minWidth: 100,
                },
                {
                  id: "actions",
                  header: "",
                  cell: (item) =>
                    item.status <= 1 && (
                      <ButtonDropdown
                        onItemClick={(id) => {
                          handleUpdateStatusEmail(item.idMailTemplate, parseInt(id.detail.id));
                        }}
                        expandToViewport
                        items={[
                          { id: "0", text: "Borrador", disabled: item.status < 1 },
                          { id: "1", text: "Pendiente", disabled: item.status > 0, disabledReason: "Correo ya esta en proceso" },
                        ]}
                        ariaLabel="Control instance"
                        variant="icon"
                      />
                    )
                  ,
                  minWidth: 50,
                }
              ]}
              wrapLines
              items={mailTemplates} />
          )}

          <ConfirmDelete
            show={showConfirmDelete}
            header='Eliminar mailing'
            subtitle={`¿Confirma que desea eliminar el correo "${mailTemplate?.subject}"?`}
            onDismiss={() => setShowConfirmDelete(false)}
            onConfirm={() => {
              handleDeleteEmail(mailTemplate?.idMailTemplate || 0);
              setShowConfirmDelete(false);
              navigate("comm/mailings/queue");
            }} confirmWord={'eliminar'} action={'Eliminar'} warning={'Esta acción no es reversible y eliminará el correo de la lista de encolamientos, aunque si el correo ya fue enviado, este no se eliminará de las bandejas de entrada de los destinatarios.'}
          />
        </SpaceBetween>
      }
    />
  );
};
